// extracted by mini-css-extract-plugin
export default {"videoContainer":"_13I422Nbav60tEWhSmU2X9"};